import { render, staticRenderFns } from "./MatterBudgetForm.vue?vue&type=template&id=5246b8f8&"
import script from "./MatterBudgetForm.vue?vue&type=script&lang=js&"
export * from "./MatterBudgetForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterBudgetForm.vue?vue&type=style&index=0&id=5246b8f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports